import lrTable from './_src/lrTable.vue'

lrTable.install = function(Vue) {
  Vue.component(lrTable.name, lrTable)
}

export default lrTable